// src/views/Settings/user/PreferencesSection.jsx
//
// Lo que te sigue cambies de organización o no: idioma, privacidad y en qué
// contexto aterrizas al entrar.
//
// No hay tema ni notificaciones porque no existen en la app —cero clases `dark:`
// en el CSS compilado—, y una preferencia que no hace nada es peor que no tenerla.
import React from 'react';
import SectionHeader from '../SectionHeader';
import UserSettingsPanels from './UserSettingsPanels';

export default function PreferencesSection() {
  return (
    <>
      <SectionHeader
        title="Preferences"
        subtitle="What follows you across organizations: language, privacy, and where you land."
      />
      <UserSettingsPanels panels={['language', 'context', 'privacy']} />
    </>
  );
}
